import React, { forwardRef, useImperativeHandle, useState, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const ToastNotification = forwardRef((_, ref) => {
    const [message, setMessage] = useState("");
    const [type, setType] = useState("success");
    const [showButtons, setShowButtons] = useState(false); // For showing the action buttons
    const [onStay, setOnStay] = useState(null); // Function to call if user clicks "Stay Logged In"
    const [onLogout, setOnLogout] = useState(null); // Function to call if user clicks "Log Out"
    const toastRef = useRef(null);

    useEffect(() => {
        if (message) {
            const timeout = setTimeout(() => setMessage(""), 5000); // Clear message after 5 seconds
            return () => clearTimeout(timeout); // Cleanup on unmount
        }
    }, [message]);

    useImperativeHandle(ref, () => ({
        showToast: (msg, toastType = "success", buttons = false, stayAction = null, logoutAction = null) => {
            setMessage(msg);
            setType(toastType);
            setShowButtons(buttons); // Show buttons if required
            setOnStay(() => stayAction); // Set the action for "Stay"
            setOnLogout(() => logoutAction); // Set the action for "Log Out"
        },
    }));

    const getToastClass = () => {
        switch (type) {
            case "success":
                return "bg-success";
            case "danger":
                return "bg-danger";
            case "warning":
                return "bg-warning";
            default:
                return "bg-success";
        }
    };

    const getIcon = () => {
        switch (type) {
            case "success":
                return <i className="bi bi-check-circle"></i>;
            case "danger":
                return <i className="bi bi-x-circle"></i>;
            case "warning":
                return <i className="bi bi-exclamation-triangle"></i>;
            default:
                return <i className="bi bi-check-circle"></i>;
        }
    };

    return (
        message && (
            <div
                ref={toastRef}
                className={`toast align-items-center text-white border-0 fade show ${getToastClass()}`}
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
                style={{
                    position: "fixed",
                    top: "20px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 999,
                }}
            >
                <div className="d-flex">
                <div className="toast-body text-reset">
                        {getIcon()} <span>{message}</span>
                        {showButtons && (
                            <div className="mt-2">
                                <button
                                    className="btn btn-sm btn-outline-light me-2"
                                    onClick={() => {
                                        if (onStay) onStay(); // Ensure function is available before calling
                                    }}
                                >
                                    Stay Logged In
                                </button>
                                <button
                                    className="btn btn-sm btn-outline-light"
                                    onClick={() => {
                                        if (onLogout) onLogout(); // Ensure function is available before calling
                                    }}
                                >
                                    Log Out
                                </button>
                            </div>
                        )}
                    </div>
                    <button
                        type="button"
                        className="btn-close btn-close-white me-2 m-auto"
                        data-bs-dismiss="toast"
                        aria-label="Close"
                        onClick={() => setMessage("")}
                    ></button>
                </div>
            </div>
        )
    );
});

export default ToastNotification;
